<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { AppState, SetNotification } from '../../../etc/stores';
  import { formatMoney, isMobile } from '../../../etc/utils';
  import Close from '../../icons/Close.svelte';
  import Text from '../../typography/Text.svelte';
  import AnimatedCoin from '../../misc/AnimatedCoin.svelte';
  import { usePostCheckoutModal } from '../../../etc/hooks/useModal';
  import { replaceVariables } from '../../../i18n';

  const positionSettings = $AppState.settings || {};

  const { open: openModal } = usePostCheckoutModal();

  const t = (text: string, values: any) => {
    return replaceVariables($_(`messages.${text}`), values);
  };

  const close = () => {
    SetNotification('', true);
  };

  const onClick = () => {
    openModal();
    close();
  };

  const firstName =
    $AppState.auth.providerData?.firstName ||
    $AppState.checkout.contactFirstName ||
    undefined;
</script>

<div class="remind-postcheckout {`twism-${positionSettings.position}`}">
  <div class="remind-postcheckout--close" on:click={close}>
    <Close fill={$AppState.theme.colors.typography} />
  </div>
  <div class="remind-postcheckout--brand" on:click={onClick}>
    <AnimatedCoin
      image={$AppState.business.logo.publicPath.large}
      scale={isMobile() ? '0.75' : '0.9'}
    />
  </div>
  <div class="remind-postcheckout--text" on:click={onClick}>
    <Text type={isMobile() ? 'medium' : 'default'}>
      {@html t('postcheckout_reminder', {
        firstName,
        businessName: $AppState.business.name,
        amount: formatMoney(
          $AppState.business.location,
          $AppState.website.coins || 0
        )
      })}
    </Text>
  </div>
</div>

<style lang="scss">
  @use './styles.scss' as *;
  .remind-postcheckout {
    width: 405px;
    height: 123px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0px 14px 48px -13px rgba(4, 33, 67, 0.26);
    display: flex;
    align-items: center;
    position: absolute;
    top: -215%;
    overflow: hidden;

    @media screen and (max-width: 468px) {
      width: 327px;
      max-width: 85vw;
    }

    &.twism-bottomRight {
      right: 0;
    }

    &--brand {
      height: 100%;
      min-width: 112px;
      background: var(--twism-theme-primary600);
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 468px) {
        min-width: 90px;
      }
    }

    &--text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 42px 0 20px;

      @media screen and (max-width: 468px) {
        padding: 0 24px 0 16px;
      }
    }

    &--close {
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0.3;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
